import { Spinner, Stack, Text3, skinVars, useDialog, IconWarningRegular } from '@telefonica/mistica';
import { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { setInfoError } from '../../../../utils/dataTransformation/errorMesssages';
import { obdTextErrorCode, obdTextErrorDescription } from '../../../../utils/dataTransformation/errorMesssages';
import { generateOnBoardingCookie } from '../../../../services/EscalationService';

const CustomerVerificationCallback: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const code = new URLSearchParams(window.location.search).get('code');
    const error_code = new URLSearchParams(window.location.search).get('error_code');
    const error_description: any = new URLSearchParams(window.location.search).get('error_description');
    const { dialog } = useDialog();
    const escalation = localStorage.getItem('escalation');
    const infoEscalation = JSON.parse(escalation!);

    const isJsonString = () => {
        try {
            JSON.parse(error_description);
        } catch (e) {
            return false;
        }
        return true;
    };
    const errorDescriptionManagement = () => {
        let error: string = '';
        if (error_description) {
            if (isJsonString()) {
                error = JSON.parse(error_description).errors[0]?.failures[0]?.message;
            } else {
                error = error_description;
            }
        } else {
            error = '1';
        }
        return error;
    };

    const handleAlert = (textError: string, id?: any) => {
        dialog({
            asset: <IconWarningRegular color={skinVars.colors.feedbackErrorBackground} size={64} />,
            title: t('profileFeedbackErrorTitle'),
            message: (() => {
                return (
                    <Stack space={16}>
                        <Text3 light color={skinVars.colors.borderHigh}>
                            {textError}
                        </Text3>
                        {id && (
                            <Text3 light color={skinVars.colors.borderHigh}>
                                {`${t('codeError')} ${id}`}
                            </Text3>
                        )}
                    </Stack>
                );
            })() as any,
            acceptText: t('buttonUnderstoodFeedback'),
            onAccept: () => window.close(),
        });
    };

    const handleError = (onBoardingId: string, redirectUri: string) => {
        const error = errorDescriptionManagement();
        if (error_code) {
            //Si hay error_code, alert con el texto de error_code
            if (obdTextErrorCode[error_code]) {
                handleAlert(obdTextErrorCode[error_code]);
            } else {
                handleAlert(t('textErrorObdGeneric'));
            }
        } else if (error_description) {
            //Si hay error_description y devuelve 1 --> alert con error genérico, sino alert con el texto de error_description
            if (error === '1') {
                handleAlert(t('textErrorObdGeneric'));
            } else {
                if (obdTextErrorDescription[error]) {
                    handleAlert(obdTextErrorDescription[error]);
                } else {
                    if (error.includes('did not pass verification') || error.includes('is not consistent')) {
                        handleAlert(t('obdErrorDaonDynamic'));
                    } else {
                        handleAlert(t('textErrorObdGeneric'));
                    }
                }
            }
        }
        //Llamar de nuevo a generateObdCookie con el error
        generateOnBoardingCookie({ onBoardingId, redirectUri, error });
    };

    useEffect(() => {
        const redirectUri = window.location.href;
        const onBoardingId = infoEscalation.onBoardingId;
        if (code) {
            //Si llega code se llama a generateOnboardigCookie
            generateOnBoardingCookie({ onBoardingId, code, redirectUri })
                //Success --> OBD
                .then(() => {
                    if (infoEscalation.state.obd === 'verification') {
                        navigate('/profile/customer-agreement', { state: { ...infoEscalation } });
                    } else {
                        setTimeout(() => {
                            localStorage.setItem('obd', JSON.stringify({ type: 'obd' }));
                            window.close();
                        }, 200);
                    }
                })
                //Error --> Alert con error generico
                .catch((error: AxiosError) => {
                    const { id } = setInfoError(error);
                    handleAlert(t('textErrorObdGeneric'), id);
                    setLoading(false);
                });
        } else {
            //Si no llega code, controlar el error_code / error_description en handleError
            setLoading(false);
            handleError(onBoardingId, redirectUri);
        }
    }, []);

    return (
        <>
            <div className='c-spinner' style={{ display: loading ? 'fixed' : 'none' }}>
                <Spinner size={24} />
                <span style={{ background: 'white' }} className='c-spinner-overlay'></span>
            </div>
        </>
    );
};

export default CustomerVerificationCallback;
